import React from "react";

function Footer() {
    return <footer>
       Made by Vipul <span role="img">❤️</span>
       
    </footer>
}

export default Footer;